const PERMISSION_GROUPS: { prefix: string; group: string; color: string }[] = [
  { prefix: 'pages:', group: 'Integrations', color: 'teal' },
  { prefix: 'meta:', group: 'Meta', color: 'grape' },
  { prefix: 'bot:', group: 'Bot', color: 'violet' },
  { prefix: 'analytics:', group: 'Analytics', color: 'blue' },
  { prefix: 'checks:', group: 'Checks', color: 'orange' },
  { prefix: 'access:', group: 'Access', color: 'red' },
  { prefix: 'ai-reports', group: 'AI Reports', color: 'cyan' },
];

type PermissionMeta = { group: string; color: string; variant: 'light' | 'filled' };

function getPermissionMeta(key: string): PermissionMeta {
  if (key === '*') return { group: '__wildcard__', color: 'yellow', variant: 'filled' };
  const match = PERMISSION_GROUPS.find(({ prefix }) => key.startsWith(prefix));
  return { group: match?.group ?? '—', color: match?.color ?? 'gray', variant: 'light' };
}

export type GroupedPermissions = PermissionMeta & { keys: string[] };

export function groupPermissions(keys: string[]): GroupedPermissions[] {
  const map = new Map<string, GroupedPermissions>();
  for (const key of keys) {
    const meta = getPermissionMeta(key);
    if (!map.has(meta.group)) {
      map.set(meta.group, { ...meta, keys: [] });
    }
    map.get(meta.group)!.keys.push(key);
  }
  return Array.from(map.values());
}
